import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=e875a60c&"
import script from "./newsletter.vue?vue&type=script&lang=js&"
export * from "./newsletter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e875a60c')) {
      api.createRecord('e875a60c', component.options)
    } else {
      api.reload('e875a60c', component.options)
    }
    module.hot.accept("./newsletter.vue?vue&type=template&id=e875a60c&", function () {
      api.rerender('e875a60c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/newsletter.vue"
export default component.exports